import React from "react";
import PropTypes from "prop-types";
import { FormattedMessage } from "react-intl";
import { css } from "@emotion/react";
import { Row } from "components/Containers";
import Icon, { ICON_SIZE, ICON_TYPE } from "components/Icon";
import { colors } from "style";

/**
 * ApplicantIsInvited
 *
 * @param {Object} data
 */
const ApplicantIsInvited = ({ data }) =>
  data?.isInvited ? (
    <Row gap="0.4rem" noWrap>
      <div css={styles.icon_container}>
        <Icon type={ICON_TYPE.checkmark} size={ICON_SIZE.small} color="inherit" />
      </div>
      <FormattedMessage id="Missions.Applicants.ApplicantInvited" />
    </Row>
  ) : null;

const styles = {
  icon_container: css`
    border-radius: 1rem;
    background: ${colors.grayAnatomyLight4};
    width: 3.5rem;
    height: 2rem;
    display: flex;
    justify-content: center;
    align-items: center;
  `,
};

ApplicantIsInvited.propTypes = {
  data: PropTypes.shape({
    isInvited: PropTypes.bool,
  }),
};

export default ApplicantIsInvited;
